import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import infrastructureAnalytics from '~/analytics/infrastructure/infrastructureAnalytics'
import { UserMenus } from '~/analytics/infrastructure/infrastructureEvents.types'
import { setMenuCurriculumDropdownExpandedActionCreator } from '~/curriculum/slice/curriculum.slice'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { closeMenu, openMenu, selectMenuIsOpen } from '~/redux/slices/menu'
import { toggleSearchBar } from '~/redux/slices/search'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function useHandleAndLogToggleMenu(): () => void {
  const dispatch = useAppDispatch()
  const isMenuOpen = useAppSelector(selectMenuIsOpen)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.SM })

  const logMenuVisibilityToggle = (showDropdown: boolean): void => {
    infrastructureAnalytics.logToggleUserMenu(UserMenus.USER_MENU, showDropdown)
  }
  return () => {
    dashboardAnalytics.handleHeaderTopMenuClick('hamburger')
    dispatch(toggleSearchBar(false))
    if (!isMobile) {
      logMenuVisibilityToggle(!isMenuOpen)
    }
    if (isMenuOpen) {
      dispatch(closeMenu())
      dispatch(setMenuCurriculumDropdownExpandedActionCreator(false))
      infrastructureAnalytics.logToggleMenu(isMobile ? 'mobile' : 'desktop', false)
    } else {
      dispatch(openMenu())
      infrastructureAnalytics.logToggleMenu(isMobile ? 'mobile' : 'desktop', true)
    }
  }
}
